var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWrpIconGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 53") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homescreen",
    transform: "translate(-145.000000, -2142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(90.000000, 2142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-53",
    transform: "translate(55.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4984783,7.48765217 C13.4984783,10.8074348 10.8071739,13.4985217 7.4876087,13.4985217 C4.16782609,13.4985217 1.47673913,10.8074348 1.47673913,7.48765217 C1.47673913,4.16786957 4.16782609,1.47678261 7.4876087,1.47678261 C10.8071739,1.47678261 13.4984783,4.16786957 13.4984783,7.48765217",
    id: "Fill-1",
    fill: "#F0C714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48752174,0.686934783 C3.73773913,0.686934783 0.686869565,3.73758696 0.686869565,7.48758696 C0.686869565,11.237587 3.73773913,14.2882391 7.48752174,14.2882391 C11.2375217,14.2882391 14.2881739,11.237587 14.2881739,7.48758696 C14.2881739,3.73758696 11.2375217,0.686934783 7.48752174,0.686934783 M7.48752174,14.9751957 C3.35904348,14.9751957 0.000130434783,11.6162826 0.000130434783,7.48758696 C0.000130434783,3.3588913 3.35904348,-2.17391304e-05 7.48752174,-2.17391304e-05 C11.6162174,-2.17391304e-05 14.9751304,3.3588913 14.9751304,7.48758696 C14.9751304,11.6162826 11.6162174,14.9751957 7.48752174,14.9751957",
    id: "Fill-3",
    fill: "#F0C714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85267391,6.77252174 C3.52463043,7.31404348 4.35832609,8.7286087 4.73267391,9.64686957 L5.14354348,9.64686957 C4.78658696,8.69991304 3.9131087,7.18991304 3.16115217,6.5336087 C3.06115217,6.61317391 2.95832609,6.69295652 2.85267391,6.77252174",
    id: "Fill-5",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.41121739,6.32978261 C4.22491304,7.1123913 5.19295652,8.69673913 5.53186957,9.64673913 L5.93556522,9.64673913 C5.61969565,8.65565217 4.5986087,6.96021739 3.70056522,6.08065217 C3.60795652,6.16282609 3.51143478,6.24608696 3.41121739,6.32978261",
    id: "Fill-7",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.93580435,5.86517391 C4.88167391,6.81386957 5.85515217,8.393 6.26863043,9.64691304 L6.66906522,9.64691304 C6.25928261,8.31408696 5.22819565,6.62169565 4.20797826,5.59778261 C4.12276087,5.68495652 4.0318913,5.77430435 3.93580435,5.86517391",
    id: "Fill-9",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85267391,6.77252174 C3.52463043,7.31404348 4.35832609,8.7286087 4.73267391,9.64686957 L5.14354348,9.64686957 C4.78658696,8.69991304 3.9131087,7.18991304 3.16115217,6.5336087 C3.06115217,6.61317391 2.95832609,6.69295652 2.85267391,6.77252174",
    id: "Fill-11",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.41121739,6.32978261 C4.22491304,7.1123913 5.19295652,8.69673913 5.53186957,9.64673913 L5.93556522,9.64673913 C5.61969565,8.65565217 4.5986087,6.96021739 3.70056522,6.08065217 C3.60795652,6.16282609 3.51143478,6.24608696 3.41121739,6.32978261",
    id: "Fill-13",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.93580435,5.86517391 C4.88167391,6.81386957 5.85515217,8.393 6.26863043,9.64691304 L6.66906522,9.64691304 C6.25928261,8.31408696 5.22819565,6.62169565 4.20797826,5.59778261 C4.12276087,5.68495652 4.0318913,5.77430435 3.93580435,5.86517391",
    id: "Fill-15",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.81945652,6.52117391 C8.16836957,7.05291304 7.06163043,8.69443478 6.67336957,9.64682609 L6.27358696,9.64682609 C6.65619565,8.63182609 7.84184783,6.86204348 8.58206522,6.2366087 L8.81945652,6.52117391 Z",
    id: "Fill-17",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37130435,6.05347826 C7.54108696,6.68173913 6.31804348,8.57304348 5.93521739,9.64673913 L5.53152174,9.64673913 C5.825,8.54086957 7.29065217,6.35586957 8.10543478,5.77565217 L8.37130435,6.05347826 Z",
    id: "Fill-19",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73930435,5.61571739 C6.71604348,6.51484783 5.59691304,8.2755 5.14452174,9.64680435 L4.73386957,9.64680435 C5.18213043,8.18919565 6.3803913,6.30136957 7.48778261,5.32832609 L7.73930435,5.61571739 Z",
    id: "Fill-21",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.81945652,6.52117391 C8.16836957,7.05291304 7.06163043,8.69443478 6.67336957,9.64682609 L6.27358696,9.64682609 C6.65619565,8.63182609 7.84184783,6.86204348 8.58206522,6.2366087 L8.81945652,6.52117391 Z",
    id: "Fill-23",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37130435,6.05347826 C7.54108696,6.68173913 6.31804348,8.57304348 5.93521739,9.64673913 L5.53152174,9.64673913 C5.825,8.54086957 7.29065217,6.35586957 8.10543478,5.77565217 L8.37130435,6.05347826 Z",
    id: "Fill-25",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.73930435,5.61571739 C6.71604348,6.51484783 5.59691304,8.2755 5.14452174,9.64680435 L4.73386957,9.64680435 C5.18213043,8.18919565 6.3803913,6.30136957 7.48778261,5.32832609 L7.73930435,5.61571739 Z",
    id: "Fill-27",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.15641304,6.52117391 C6.8075,7.05291304 7.91423913,8.69443478 8.3025,9.64682609 L8.70228261,9.64682609 C8.31967391,8.63182609 7.13402174,6.86204348 6.39402174,6.2366087 L6.15641304,6.52117391 Z",
    id: "Fill-29",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60458696,6.05347826 C7.43480435,6.68173913 8.65784783,8.57304348 9.0408913,9.64673913 L9.44436957,9.64673913 C9.1508913,8.54086957 7.68545652,6.35586957 6.87067391,5.77565217 L6.60458696,6.05347826 Z",
    id: "Fill-31",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23680435,5.61571739 C8.26006522,6.51484783 9.37919565,8.2755 9.83158696,9.64680435 L10.2420217,9.64680435 C9.79397826,8.18919565 8.5955,6.30136957 7.4881087,5.32832609 L7.23680435,5.61571739 Z",
    id: "Fill-33",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.15641304,6.52117391 C6.8075,7.05291304 7.91423913,8.69443478 8.3025,9.64682609 L8.70228261,9.64682609 C8.31967391,8.63182609 7.13402174,6.86204348 6.39402174,6.2366087 L6.15641304,6.52117391 Z",
    id: "Fill-35",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60458696,6.05347826 C7.43480435,6.68173913 8.65784783,8.57304348 9.0408913,9.64673913 L9.44436957,9.64673913 C9.1508913,8.54086957 7.68545652,6.35586957 6.87067391,5.77565217 L6.60458696,6.05347826 Z",
    id: "Fill-37",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23680435,5.61571739 C8.26006522,6.51484783 9.37919565,8.2755 9.83158696,9.64680435 L10.2420217,9.64680435 C9.79397826,8.18919565 8.5955,6.30136957 7.4881087,5.32832609 L7.23680435,5.61571739 Z",
    id: "Fill-39",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.122587,6.77252174 C11.450413,7.31404348 10.6167174,8.7286087 10.242587,9.64686957 L9.83171739,9.64686957 C10.1884565,8.69991304 11.0621522,7.18991304 11.8138913,6.5336087 C11.9138913,6.61317391 12.0169348,6.69295652 12.122587,6.77252174",
    id: "Fill-41",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5597826,6.33730435 C10.7478261,7.12252174 9.78478261,8.69969565 9.44695652,9.64686957 L9.04326087,9.64686957 C9.35804348,8.6586087 10.3743478,6.97013043 11.2704348,6.08817391 C11.3630435,6.17056522 11.4595652,6.2536087 11.5597826,6.33730435",
    id: "Fill-43",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0281957,5.87069565 C10.0838478,6.82004348 9.11319565,8.39547826 8.70058696,9.64678261 L8.30015217,9.64678261 C8.7095,8.31656522 9.73732609,6.62786957 10.755587,5.60330435 C10.8410217,5.69069565 10.9318913,5.78004348 11.0281957,5.87069565",
    id: "Fill-45",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.122587,6.77252174 C11.450413,7.31404348 10.6167174,8.7286087 10.242587,9.64686957 L9.83171739,9.64686957 C10.1884565,8.69991304 11.0621522,7.18991304 11.8138913,6.5336087 C11.9138913,6.61317391 12.0169348,6.69295652 12.122587,6.77252174",
    id: "Fill-47",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5597826,6.33730435 C10.7478261,7.12252174 9.78478261,8.69969565 9.44695652,9.64686957 L9.04326087,9.64686957 C9.35804348,8.6586087 10.3743478,6.97013043 11.2704348,6.08817391 C11.3630435,6.17056522 11.4595652,6.2536087 11.5597826,6.33730435",
    id: "Fill-49",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0281957,5.87069565 C10.0838478,6.82004348 9.11319565,8.39547826 8.70058696,9.64678261 L8.30015217,9.64678261 C8.7095,8.31656522 9.73732609,6.62786957 10.755587,5.60330435 C10.8410217,5.69069565 10.9318913,5.78004348 11.0281957,5.87069565",
    id: "Fill-51",
    fill: "#FFFFFF"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrpIconGold);
export default __webpack_public_path__ + "static/media/wrp-icon-gold.c20c66d675a667820ccc4b30d68e0615.svg";
export { ForwardRef as ReactComponent };